// jQuery
global.jQuery = require('jquery');
global.$ = global.jQuery;

jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchmove", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
jQuery.event.special.wheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("wheel", handle, {passive: true});
    }
};
jQuery.event.special.mousewheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("mousewheel", handle, {passive: true});
    }
};

$(function () {

    let app = require('./modules/core')();
    app.initBootstrap();
    app.initLazyLoad();
    //app.initLightbox(); // Use Spotlight for galleries - comment this in if you need it
    app.initSlickCarousel();
    app.scrollToAnchor();
    app.scrollToAccordionItem();
    app.detectUrlScrollHash();
    app.convertCryptedEmails();
    app.initMobileMenu();
    app.initRrssb();
    app.initPopups();
    app.initSpotlightJs();
    app.initTingleModalJs();
    app.initSearchBar();
    app.bornHS();

    //app.navDropdownHover(); // Hover instead of click on Nav dropdowns
    //app.initDatePicker();
    app.initWowJs();
    app.initStickyEl();
    app.keepTokenAlive();
    //app.initTooltips();
    app.announcementBarDismiss();
    app.cartInit();

    // let googleMaps = require('./modules/google-maps')();
    // googleMaps.assign();


    $(".megamenu").on("click", function (e) {
        e.stopPropagation();
    });




});




$(function () {
    let timeout = null;

    $('#GlobalSearch').keyup(function () {
        $('.results-container').html('').addClass('d-none');

        //clearTimeout(timeout); // this will clear the recursive unneccessary calls

        //timeout = setTimeout(() => {

        if (window.google_tag_manager)
            gtag('event', 'search', {
                'event_category': 'engagement',
                'event_label': $(this).val()
            });

        $.ajax({
            type: 'POST',
            url: '/api/search',
            data: {search: $(this).val()},
            dataType: 'json',
            headers: {'x-csrf-token': $('meta[name=csrf-token]').attr('content')},
            statusCode: {
                200: function (result) {
                    console.log(result);

                    if (result.count)
                        $('.results-container').removeClass('d-none').html(result.html)

                    return true;
                },

                500: function (xhr) {
                    $('.results-container').addClass('d-none')
                    return false;
                }
            }
        });
        //, 100);

    }).on('focusout', function () {

        setTimeout(function () {
            $('.results-container').html('').addClass('d-none');
        }, 200);
    });


    $('.hide-on-submit').click(function(){
        $(this).attr('disabled', 'disabled')
            .addClass('rounded-max')
            .html('<i class="fa fa-spin fa-spinner"></i>');
        $(this).parents('form').submit();
    });
});



/*Slide Out Menu JS*/
if (!window.menuScriptLoaded) {
    window.menuScriptLoaded = true;

    document.addEventListener('DOMContentLoaded', () => {

        // --- 1. OPEN LEVEL 1 ---
        document.querySelectorAll('.js-menu-trigger').forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();

                // Close any other open menus first
                closeAll();

                const targetID = trigger.getAttribute('data-target');
                const targetMenu = document.querySelector(targetID);

                // Find the specific overlay for this menu ID
                // We assume the ID format is #menu-slug, so we look for #overlay-slug
                const slug = targetID.replace('#menu-', '');
                const overlay = document.querySelector(`#overlay-${slug}`);

                if (targetMenu) {
                    if (overlay) overlay.classList.add('active');
                    targetMenu.classList.add('active');
                    document.body.classList.add('no-scroll');
                }
            });
        });

        // --- 2. OPEN LEVEL 2 ---
        document.querySelectorAll('.action-open-level2').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();

                // Get specific targets from data attributes
                const menuTarget = btn.getAttribute('data-menu-target');
                const panelTarget = btn.getAttribute('data-panel-target');

                const level2Menu = document.querySelector(menuTarget);
                const panel = document.querySelector(panelTarget);

                if (level2Menu && panel) {
                    // Hide all other panels IN THIS SPECIFIC MENU
                    level2Menu.querySelectorAll('.submenu-panel').forEach(p => p.classList.remove('active'));

                    // Activate correct panel and menu
                    panel.classList.add('active');
                    level2Menu.classList.add('active');
                }
            });
        });

        // --- 3. BACK BUTTON ---
        // We use 'closest' so it works for ANY Level 2 menu
        document.querySelectorAll('.action-back').forEach(btn => {
            btn.addEventListener('click', function () {
                const parentMenu = this.closest('.slide-menu');
                if (parentMenu) parentMenu.classList.remove('active');
            });
        });

        // --- 4. CLOSE EVERYTHING ---
        function closeAll() {
            document.querySelectorAll('.slide-menu.active').forEach(el => el.classList.remove('active'));
            document.querySelectorAll('.menu-overlay.active').forEach(el => el.classList.remove('active'));
            document.body.classList.remove('no-scroll');
        }

        document.querySelectorAll('.action-close').forEach(btn => {
            btn.addEventListener('click', closeAll);
        });
    });
}
